import Box from "@material-ui/core/Box";
import React, {useRef} from "react";
import {Col, Row, Space} from "antd";
import {Avatar, Button, FormControl, FormHelperText, InputLabel, MenuItem, Select, TextField} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import CloseIcon from "@material-ui/icons/Close";
import Divider from "@material-ui/core/Divider";
import {Form, FormikProvider} from 'formik'
import {useDispatch, useSelector} from "react-redux";
import {convertImageToDataString, selectImageUtil} from "../../../redux/slices/image";
import useStyles from "./styles";


export default function UserDetailsBaseSection({user, onChange, formik, loading = false}) {
    const classes = useStyles();
    const fileInput = useRef();
    const dispatch = useDispatch();
    const {image} = useSelector(selectImageUtil)

    const handleAvatarSetting = () => {
        if (fileInput && fileInput.current) {
            dispatch(convertImageToDataString({image: fileInput.current.files[0]}))
        }
    }

    const handleAvatarSelection = () => fileInput && fileInput.current && fileInput.current.click()

    const handleAvatarReset = () => dispatch(convertImageToDataString({image: null}))

    const {
        errors,
        touched,
        handleSubmit,
        getFieldProps,
    } = formik;


    return (
        <Box className={classes.container}>
            <FormikProvider value={formik}>
                <Form onSubmit={handleSubmit}>

                    <Row justify={"center"}>

                        <Space direction={'vertical'} size={"large"}>
                            <Row justify={'center'}>
                                <Avatar
                                    sizes={'large'}
                                    className={classes.avatar}
                                    src={image ?? user?.photoURL}
                                />
                            </Row>

                            <Row justify={'center'}>
                                <Col>
                                    <Button variant={'outlined'} color={'primary'} startIcon={<EditIcon/>}
                                            disabled={loading}
                                            onClick={handleAvatarSelection}>
                                        Changer
                                    </Button>
                                </Col>

                                <Col style={{marginLeft: 10}}>
                                    <Button variant={'outlined'} color={'secondary'} startIcon={<CloseIcon/>}
                                            disabled={loading}
                                            onClick={handleAvatarReset}>
                                        Supprimer
                                    </Button>
                                </Col>
                            </Row>

                            <Divider/>

                            <Row justify={'center'}>
                                <TextField
                                    className={classes.textField}
                                    label={'Email'}
                                    error={Boolean(touched.email && errors.email)}
                                    helperText={touched.email && errors.email}
                                    {...getFieldProps('email')}
                                    disabled={user?.email === null|| loading}
                                />
                            </Row>

                            <Row justify={'center'}>
                                <TextField
                                    className={classes.textField}
                                    label={'Non a afficher'}
                                    error={Boolean(touched.displayName && errors.displayName)}
                                    helperText={touched.displayName && errors.displayName}
                                    {...getFieldProps('displayName')}
                                    disabled={loading}
                                />
                            </Row>

                            <Row justify={'center'}>
                                <FormControl>
                                    <InputLabel>Etat du compte</InputLabel>
                                    <Select
                                        className={classes.select}
                                        error={Boolean(touched.disabled && errors.disabled)}
                                        {...getFieldProps('disabled')}
                                        disabled={loading}
                                    >
                                        <MenuItem value={false}>Actif</MenuItem>
                                        <MenuItem value={true}>Bloque</MenuItem>
                                    </Select>
                                    {
                                        touched.disabled && errors.disabled && (
                                            <FormHelperText>
                                                {touched.disabled && errors.disabled}
                                            </FormHelperText>
                                        )
                                    }
                                </FormControl>
                            </Row>


                            <Row justify={'center'}>
                                <TextField
                                    className={classes.textField}
                                    label={'Mots de passe'}
                                    error={Boolean(touched.password && errors.password)}
                                    helperText={touched.password && errors.password}
                                    {...getFieldProps('password')}
                                    disabled={loading}
                                    type={'password'}
                                />
                            </Row>

                        </Space>

                    </Row>

                    <input type={'file'} accept="image/*" ref={fileInput} hidden onChange={handleAvatarSetting}/>

                </Form>
            </FormikProvider>

        </Box>
    )
}